var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEuBadge = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  width: 20,
  height: 24,
  x: 2,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12.503.119a1.13 1.13 0 0 0-1.006 0L2.872 4.43a1.12 1.12 0 0 0-.622 1.005v6.52c0 3.661 2.03 6.657 4.17 8.699a17 17 0 0 0 3.166 2.392c.482.278.932.498 1.324.65.369.145.757.259 1.09.259s.721-.114 1.09-.258c.392-.153.842-.373 1.324-.651a17 17 0 0 0 3.166-2.393c2.14-2.041 4.17-5.037 4.17-8.698v-6.52c0-.43-.244-.816-.622-1.005z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#04985A",
  d: "M12.503.119a1.13 1.13 0 0 0-1.006 0L2.872 4.43a1.12 1.12 0 0 0-.622 1.005v6.52c0 3.661 2.03 6.657 4.17 8.699a17 17 0 0 0 3.166 2.392c.482.278.932.498 1.324.65.369.145.757.259 1.09.259s.721-.114 1.09-.258c.392-.153.842-.373 1.324-.651a17 17 0 0 0 3.166-2.393c2.14-2.041 4.17-5.037 4.17-8.698v-6.52c0-.43-.244-.816-.622-1.005z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#05B86C",
  d: "m12 1.544 8.25 4.125v6.287c0 3.088-1.72 5.718-3.705 7.613a15.5 15.5 0 0 1-2.88 2.178c-.433.25-.815.434-1.12.554a3 3 0 0 1-.38.125q-.075.019-.122.025l-.043.005z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.143 11.4c0-1.214.38-2.27 1.037-3.012C9.827 7.658 10.77 7.2 12 7.2s2.173.458 2.82 1.188c.657.742 1.037 1.798 1.037 3.012s-.38 2.27-1.037 3.012q-.093.104-.192.2c-.647.618-1.545.988-2.628.988s-1.981-.37-2.628-.988a4 4 0 0 1-.192-.2c-.657-.742-1.037-1.798-1.037-3.012M19.664 22.81a.06.06 0 0 0 .05-.061V21.6c0-2.746-1.932-5.143-4.698-5.71-.812.577-1.832.91-3.016.91s-2.204-.333-3.016-.91c-2.766.567-4.698 2.964-4.698 5.71v1.148c0 .03.02.056.05.062L12 24.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#07985A",
  d: "M5.797 17.697c.504.684 1.07 1.31 1.658 1.873.987.941 2.017 1.679 2.88 2.177.433.25.814.434 1.12.554q.22.086.379.125a1 1 0 0 0 .166.03q.001.001.043-.005.045-.006.123-.025.158-.04.378-.125c.306-.12.688-.304 1.12-.553a15.5 15.5 0 0 0 2.88-2.178 14.5 14.5 0 0 0 1.659-1.873c.355.39.656.828.893 1.3a17.002 17.002 0 0 1-4.683 4.05 10 10 0 0 1-1.323.65c-.369.145-.758.259-1.09.259s-.722-.114-1.09-.258a10 10 0 0 1-1.324-.651 17 17 0 0 1-4.683-4.05 5.8 5.8 0 0 1 .894-1.3"
}))));
export default SvgEuBadge;